import { render, staticRenderFns } from "./SimpleDisplayGrid.vue?vue&type=template&id=0e7c5c68&scoped=true&"
import script from "./SimpleDisplayGrid.vue?vue&type=script&lang=js&"
export * from "./SimpleDisplayGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7c5c68",
  null
  
)

export default component.exports